module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/local-market-stats-36cb2ffd09bbc40c4bd1f3d81c36b177.svg";